import React from "react";
import { Link } from "react-router-dom";
import "../styles/Home.css";

const Disclaimer = () => {
  return (
    <div className="gybtc-container">
      <header className="gybtc-header scrolled">
        <div className="gybtc-header-content">
          <div className="gybtc-logo-container">
            <img
              src="/gybtc-logo.png"
              alt="Grow Your BTC Logo"
              className="gybtc-logo"
            />
          </div>

          <nav className="gybtc-nav">
            <Link to="/" className="gybtc-nav-link">Home</Link>
            <Link to="/faq" className="gybtc-nav-link">FAQ</Link>
            <Link to="/terms" className="gybtc-nav-link">Terms</Link>
            <Link to="/privacy" className="gybtc-nav-link">Privacy</Link>
            <a href="/book" className="gybtc-btn-nav-cta">Book 1:1</a>
          </nav>
        </div>
      </header>

      <section className="gybtc-about" style={{ paddingTop: "140px", minHeight: "100vh" }}>
        <div className="gybtc-section-header">
          <h1 className="gybtc-section-title">Disclaimer</h1>
        </div>

        <div className="gybtc-about-grid" style={{ gridTemplateColumns: "1fr" }}>
          <div className="gybtc-about-card">
            <p className="gybtc-about-card-text">
              Grow Your BTC provides educational content, personal guidance, and general
              information only.
            </p>

            <h3 className="gybtc-about-card-title">Not financial advice</h3>
            <p className="gybtc-about-card-text">
              Nothing on this website, in newsletters, in courses, in 1:1 sessions, or in
              related materials should be considered financial, investment, legal, tax, or
              regulated professional advice.
            </p>

            <h3 className="gybtc-about-card-title">Bitcoin involves risk</h3>
            <p className="gybtc-about-card-text">
              Bitcoin is volatile and involves risk, including market risk, custody risk,
              technical risk, user error, software risk, and regulatory uncertainty. You are
              solely responsible for your own decisions.
            </p>

            <h3 className="gybtc-about-card-title">No guarantees</h3>
            <p className="gybtc-about-card-text">
              Grow Your BTC makes no guarantees regarding outcomes, profits, losses, Bitcoin
              price performance, portfolio growth, or security results.
            </p>

            <h3 className="gybtc-about-card-title">Self-custody responsibility</h3>
            <p className="gybtc-about-card-text">
              If you choose to self-custody Bitcoin, you are responsible for safeguarding your
              devices, seed phrases, passwords, backups, and recovery methods.
            </p>

            <h3 className="gybtc-about-card-title">Personal responsibility</h3>
            <p className="gybtc-about-card-text">
              You remain fully responsible for your own financial decisions, actions, wallet
              setup, exchange use, tax reporting, and compliance with applicable laws.
            </p>

            <h3 className="gybtc-about-card-title">Third-party tools</h3>
            <p className="gybtc-about-card-text">
              References to third-party wallets, services, exchanges, apps, or platforms do
              not constitute endorsements or guarantees.
            </p>
          </div>
        </div>
      </section>

      <footer id="footer" className="gybtc-footer">
        <div className="gybtc-footer-content">
          <p className="gybtc-footer-text">
            © 2025 Grow Your BTC • <Link to="/privacy">Privacy Policy</Link> •{" "}
            <Link to="/terms">Terms</Link> • <Link to="/disclaimer">Disclaimer</Link> •{" "}
            <Link to="/faq">FAQ</Link>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Disclaimer;
